// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputs_inputLabel__eGMuB {
  text-align: left;
  color: #4b5563;
  font-weight: 500;
}

.inputs_inputLabel__eGMuB:first-letter {
  text-transform: uppercase;
}

.inputs_inputBorderDefault__9yFL9 {
  padding: 12px !important;
  border: 1px solid #cccccc !important;
  font-size: 0.9rem !important;
}

.inputs_inputBorderDefault__9yFL9:focus {
  border: 1px solid var(--global-main-color) !important;
  outline: none !important;
  box-shadow: none !important;
}

/* RADIO */

.inputs_customRadio__ZhWF7 {
  display: flex;
  flex-direction: column;
}

.inputs_customRadio__ZhWF7 .inputs_radioOption__tIXkw {
  display: flex;
  align-items: center;
  margin-bottom: 0.3rem;
}

.inputs_customRadio__ZhWF7 input[type="radio"] {
  display: none;
}

.inputs_customRadio__ZhWF7 label {
  display: inline-block;
  position: relative;
  padding-left: 1.8rem;
  cursor: pointer;
  font-size: 0.9rem;
  color: #6b728c;
}

.inputs_customRadio__ZhWF7 label:before {
  content: "";
  display: inline-block;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1.2rem;
  height: 1.2rem;
  border: 1px solid #d9dde2;
  border-radius: 50%;
}

.inputs_customRadio__ZhWF7 label:after {
  content: "";
  display: none;
  position: absolute;
  left: 0.25rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0.7rem;
  height: 0.7rem;
  background-color: var(--global-main-color);
  border-radius: 50%;
}

.inputs_customRadio__ZhWF7 input[type="radio"]:checked + label:before {
  border: 1px solid var(--global-main-color);
}

.inputs_customRadio__ZhWF7 input[type="radio"]:checked + label:after {
  display: inline-block;
}

/* SELECT */

.inputs_customSelect__uPVDe {
  position: relative;
  width: 100%;
}

.inputs_customSelect__uPVDe .inputs_dropdownButton__klCna {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  color: #6b768c;
}

.inputs_customSelect__uPVDe .inputs_dropdownButton__klCna:focus,
.inputs_customSelect__uPVDe .inputs_dropdownButton__klCna:hover {
  border-color: var(--global-main-color);
}

.inputs_customSelect__uPVDe .inputs_dropdownOptions__vFJNN {
  overflow-y: scroll;
  max-height: 300px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  display: none;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  cursor: pointer;
  z-index: 100;
}

.inputs_customSelect__uPVDe .inputs_dropdownOptions__vFJNN.inputs_show__ZRbbl {
  display: block;
}

.inputs_customSelect__uPVDe .inputs_dropdownOptions__vFJNN div {
  padding: 9px 10px 9px 10px;
  border-bottom: 1px solid #d1d5db;
  text-align: left;
}

.inputs_customSelect__uPVDe .inputs_dropdownOptions__vFJNN div:last-child {
  border-bottom: none;
}

.inputs_customSelect__uPVDe .inputs_dropdownOptions__vFJNN div:hover {
  background-color: #f9f9f9;
}

.inputs_customSelect__uPVDe .inputs_dropdownOptions__vFJNN div.inputs_selected__qRf3o {
  background-color: rgb(238, 238, 238, 0.9);
}

/* FILE */

.inputs_fileInputOutsideContainer__VBznR {
  background-color: #ffffff;
  box-shadow: 0 0 3px darkgray;
  border-radius: 5px;
  margin: 0 0 1.5rem 0;
}

.inputs_fileInputContainer__xkCuQ {
  position: relative;
  display: inline-block;
  width: 90%;
}

.inputs_fileInput__3s7bN {
  position: relative;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: #d1d5db dashed 2px;
  border-radius: 5px;
}

.inputs_fileInput__3s7bN:focus {
  border: 1px dashed var(--global-main-color);
}

.inputs_uploadText__FFNDn {
  text-align: center;
  color: #6b7280;
}

.inputs_fileList__gX09C {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-content: start;
}

.inputs_fileItem__fw38l {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
  border: grey solid 1px;
  border-radius: 3px;
}

.inputs_previewImage__4wh6J {
  border-radius: 3px;
  width: auto;
  height: 60px;
  object-fit: cover;
}

.inputs_defaultColorText__xbiZV {
  color: #42a687;
  font-weight: 500;
  margin-right: 5px;
}

/* PRIMARY BUTTON */

.inputs_primaryButton__Nqp5i {
  text-align: center;
  background-color: var(--global-main-color);
  padding: 12px 18px 12px 18px;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 500;
}

.inputs_primaryButton__Nqp5i:active {
  background-color: var(--global-main-color-pressed);
}

/* SECONDARY BUTTON */

.inputs_secondaryButton__QFxmT {
  font-weight: 500;
  background-color: #f3f4f6;
  padding: 12px 18px 12px 18px;
  border-radius: 5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  color: #7c7280;
  transition: color, background-color 0.1s linear;
  border: #9ca3af solid 1px;
}

.inputs_secondaryButton__QFxmT:hover {
  border: var(--global-main-color) solid 1px;
  background-color: var(--global-main-color);
  color: #ffffff;
}

.inputs_secondaryButton__QFxmT:active {
  border: var(--global-main-color-pressed) solid 1px;
  background-color: var(--global-main-color-pressed);
  color: #ffffff;
}

/* DANGER BUTTON */

.inputs_dangerButton__z7Zhs {
  font-weight: 500;
  background-color: #e32a0f;
  padding: 12px 18px 12px 18px;
  border-radius: 5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  color: #ffffff;
}

.inputs_dangerButton__z7Zhs:active {
  background-color: #c91c08;
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/styles/inputs.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;EACrD,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,SAAS;;AAET;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mBAAmB;;AAEnB;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;AACpD;;AAEA,qBAAqB;;AAErB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,kDAAkD;EAClD,cAAc;AAChB;;AAEA,kBAAkB;;AAElB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".inputLabel {\n  text-align: left;\n  color: #4b5563;\n  font-weight: 500;\n}\n\n.inputLabel:first-letter {\n  text-transform: uppercase;\n}\n\n.inputBorderDefault {\n  padding: 12px !important;\n  border: 1px solid #cccccc !important;\n  font-size: 0.9rem !important;\n}\n\n.inputBorderDefault:focus {\n  border: 1px solid var(--global-main-color) !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n/* RADIO */\n\n.customRadio {\n  display: flex;\n  flex-direction: column;\n}\n\n.customRadio .radioOption {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.3rem;\n}\n\n.customRadio input[type=\"radio\"] {\n  display: none;\n}\n\n.customRadio label {\n  display: inline-block;\n  position: relative;\n  padding-left: 1.8rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #6b728c;\n}\n\n.customRadio label:before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1.2rem;\n  height: 1.2rem;\n  border: 1px solid #d9dde2;\n  border-radius: 50%;\n}\n\n.customRadio label:after {\n  content: \"\";\n  display: none;\n  position: absolute;\n  left: 0.25rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0.7rem;\n  height: 0.7rem;\n  background-color: var(--global-main-color);\n  border-radius: 50%;\n}\n\n.customRadio input[type=\"radio\"]:checked + label:before {\n  border: 1px solid var(--global-main-color);\n}\n\n.customRadio input[type=\"radio\"]:checked + label:after {\n  display: inline-block;\n}\n\n/* SELECT */\n\n.customSelect {\n  position: relative;\n  width: 100%;\n}\n\n.customSelect .dropdownButton {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n  cursor: pointer;\n  color: #6b768c;\n}\n\n.customSelect .dropdownButton:focus,\n.customSelect .dropdownButton:hover {\n  border-color: var(--global-main-color);\n}\n\n.customSelect .dropdownOptions {\n  overflow-y: scroll;\n  max-height: 300px;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  display: none;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  cursor: pointer;\n  z-index: 100;\n}\n\n.customSelect .dropdownOptions.show {\n  display: block;\n}\n\n.customSelect .dropdownOptions div {\n  padding: 9px 10px 9px 10px;\n  border-bottom: 1px solid #d1d5db;\n  text-align: left;\n}\n\n.customSelect .dropdownOptions div:last-child {\n  border-bottom: none;\n}\n\n.customSelect .dropdownOptions div:hover {\n  background-color: #f9f9f9;\n}\n\n.customSelect .dropdownOptions div.selected {\n  background-color: rgb(238, 238, 238, 0.9);\n}\n\n/* FILE */\n\n.fileInputOutsideContainer {\n  background-color: #ffffff;\n  box-shadow: 0 0 3px darkgray;\n  border-radius: 5px;\n  margin: 0 0 1.5rem 0;\n}\n\n.fileInputContainer {\n  position: relative;\n  display: inline-block;\n  width: 90%;\n}\n\n.fileInput {\n  position: relative;\n  width: 100%;\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: #d1d5db dashed 2px;\n  border-radius: 5px;\n}\n\n.fileInput:focus {\n  border: 1px dashed var(--global-main-color);\n}\n\n.uploadText {\n  text-align: center;\n  color: #6b7280;\n}\n\n.fileList {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: row;\n  align-content: start;\n}\n\n.fileItem {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n  margin-right: 10px;\n  border: grey solid 1px;\n  border-radius: 3px;\n}\n\n.previewImage {\n  border-radius: 3px;\n  width: auto;\n  height: 60px;\n  object-fit: cover;\n}\n\n.defaultColorText {\n  color: #42a687;\n  font-weight: 500;\n  margin-right: 5px;\n}\n\n/* PRIMARY BUTTON */\n\n.primaryButton {\n  text-align: center;\n  background-color: var(--global-main-color);\n  padding: 12px 18px 12px 18px;\n  border-radius: 5px;\n  color: #fff;\n  cursor: pointer;\n  user-select: none;\n  font-weight: 500;\n}\n\n.primaryButton:active {\n  background-color: var(--global-main-color-pressed);\n}\n\n/* SECONDARY BUTTON */\n\n.secondaryButton {\n  font-weight: 500;\n  background-color: #f3f4f6;\n  padding: 12px 18px 12px 18px;\n  border-radius: 5px;\n  cursor: pointer;\n  user-select: none;\n  color: #7c7280;\n  transition: color, background-color 0.1s linear;\n  border: #9ca3af solid 1px;\n}\n\n.secondaryButton:hover {\n  border: var(--global-main-color) solid 1px;\n  background-color: var(--global-main-color);\n  color: #ffffff;\n}\n\n.secondaryButton:active {\n  border: var(--global-main-color-pressed) solid 1px;\n  background-color: var(--global-main-color-pressed);\n  color: #ffffff;\n}\n\n/* DANGER BUTTON */\n\n.dangerButton {\n  font-weight: 500;\n  background-color: #e32a0f;\n  padding: 12px 18px 12px 18px;\n  border-radius: 5px;\n  cursor: pointer;\n  user-select: none;\n  color: #ffffff;\n}\n\n.dangerButton:active {\n  background-color: #c91c08;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputLabel": `inputs_inputLabel__eGMuB`,
	"inputBorderDefault": `inputs_inputBorderDefault__9yFL9`,
	"customRadio": `inputs_customRadio__ZhWF7`,
	"radioOption": `inputs_radioOption__tIXkw`,
	"customSelect": `inputs_customSelect__uPVDe`,
	"dropdownButton": `inputs_dropdownButton__klCna`,
	"dropdownOptions": `inputs_dropdownOptions__vFJNN`,
	"show": `inputs_show__ZRbbl`,
	"selected": `inputs_selected__qRf3o`,
	"fileInputOutsideContainer": `inputs_fileInputOutsideContainer__VBznR`,
	"fileInputContainer": `inputs_fileInputContainer__xkCuQ`,
	"fileInput": `inputs_fileInput__3s7bN`,
	"uploadText": `inputs_uploadText__FFNDn`,
	"fileList": `inputs_fileList__gX09C`,
	"fileItem": `inputs_fileItem__fw38l`,
	"previewImage": `inputs_previewImage__4wh6J`,
	"defaultColorText": `inputs_defaultColorText__xbiZV`,
	"primaryButton": `inputs_primaryButton__Nqp5i`,
	"secondaryButton": `inputs_secondaryButton__QFxmT`,
	"dangerButton": `inputs_dangerButton__z7Zhs`
};
export default ___CSS_LOADER_EXPORT___;
